import React, { useContext, useState } from "react";
import { Form, Input, Button, Typography, Space } from "antd";
import { CopyOutlined, MailOutlined } from "@ant-design/icons";
import { adminContext } from "../../Common/PageRoute";
import { SAModal } from "../../Common/Custom Components/Ant design/SAModal";
import PracticeDataRequestService from "../../Services/PracticeDataRequestService";
import { Utils } from "../../Utilities/Utils";

const { Title, Text } = Typography;

const GenerateRequestModal = ({ onDismiss }: { onDismiss: (added?: boolean) => void }) => {
  const [form] = Form.useForm();
  const { openNotification } = useContext(adminContext);
  const [loading, setLoading] = useState(false);
  const [generatedLink, setGeneratedLink] = useState<string | null>(null);

  const handleGenerate = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      
      const res = await PracticeDataRequestService.generateLink(values);
      if (res.status && res.result) {
        openNotification("success", "Request link generated and email sent!");
        const link = `${window.location.origin}/data-request/${res.result.token}`;
        setGeneratedLink(link);
      } else {
        openNotification("error", res.message || "Failed to generate link");
      }
    } catch (error: any) {
      // Form validation error
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = () => {
    if (generatedLink) {
      navigator.clipboard.writeText(generatedLink);
      openNotification("success", "Link copied to clipboard");
    }
  };

  return (
    <SAModal
      open={true}
      title="Generate Data Request Link"
      onCancel={() => onDismiss(!!generatedLink)}
      footer={null}
      width={600}
    >
      {!generatedLink ? (
        <Form form={form} layout="vertical" onFinish={handleGenerate}>
          <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
            Enter the client's email address. They will receive a unique, secure link to fill out their practice details and upload data conversion files.
          </Text>
          <Form.Item name="clientEmail" label="Client Email" rules={[{ required: true, message: "Required" }, { validator: Utils.ValidateEmailFormat }]}>
            <Input placeholder="client@example.com" />
          </Form.Item>
          
          <div style={{ textAlign: 'right', marginTop: 24 }}>
            <Space>
              <Button onClick={() => onDismiss()}>Cancel</Button>
              <Button type="primary" htmlType="submit" loading={loading} icon={<MailOutlined />}>
                Generate Link & Send Email
              </Button>
            </Space>
          </div>
        </Form>
      ) : (
        <div style={{ textAlign: 'center', padding: '24px 0' }}>
          <Title level={4} style={{ color: '#52c41a' }}>Link Generated Successfully!</Title>
          <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
            An email has been sent to the client. You can also copy the direct link below if you need to send it manually.
          </Text>
          
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 24 }}>
            <Input value={generatedLink} readOnly style={{ width: '80%', marginRight: 8 }} />
            <Button type="primary" icon={<CopyOutlined />} onClick={handleCopy}>Copy</Button>
          </div>

          <Button onClick={() => onDismiss(true)}>Close</Button>
        </div>
      )}
    </SAModal>
  );
};

export default GenerateRequestModal;
